<template>
    <Modal class="popup_content" v-model="invoiceshow" width="560" @on-cancel="invoiceCancel">
        <div slot="header" class="popup_header_content">
            <span v-if="type == 1">普通发票</span>
            <span v-else>增值税专用发票</span>
        </div>
        <div class="popup_head_body">
            <!-- 普通发票 -->
            <div class="invoice_box" v-if="type == 1">
                <Form ref="invoiceOneValidate" :model="invoiceOneValidate" :rules="ruleinvoiceOneValidate" :show-message="false" :label-width="172">
                    <FormItem label="发票抬头：" prop="title">
                        <Input v-model="invoiceOneValidate.title" placeholder="输入您的公司、店铺名称" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="纳税人识别号：" prop="number">
                        <Input v-model="invoiceOneValidate.number" placeholder="输入纳税人识别号" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="发票内容：" prop="content">
                        <Input v-model="invoiceOneValidate.content" placeholder="请输入发票内容" style="width: 310px;" />
                    </FormItem>
                </Form>
            </div>
            <!-- 增值税专用发票 -->
            <div class="invoice_box" v-else>
                <Form ref="invoiceTwoValidate" :model="invoiceTwoValidate" :rules="ruleinvoiceTwoValidate" :show-message="false" :label-width="172">
                    <FormItem label="发票抬头：" prop="title">
                        <Input v-model="invoiceTwoValidate.title" placeholder="输入您的公司、店铺名称" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="纳税人识别号：" prop="number">
                        <Input v-model="invoiceTwoValidate.number" placeholder="输入纳税人识别号" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="注册地址：" prop="address">
                        <Input v-model="invoiceTwoValidate.address" placeholder="输入注册地址" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="注册电话：" prop="phone">
                        <Input v-model="invoiceTwoValidate.phone" placeholder="请输入注册电话" :maxlength="11" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="开户银行：" prop="bankname">
                        <Input v-model="invoiceTwoValidate.bankname" placeholder="请选择开户银行" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="银行帐户：" prop="banknumber">
                        <Input v-model="invoiceTwoValidate.banknumber" placeholder="请输入银行账户" style="width: 310px;" />
                    </FormItem>
                    <FormItem label="发票内容：" prop="content">
                        <Input v-model="invoiceTwoValidate.content" placeholder="请输入发票内容" style="width: 310px;" />
                    </FormItem>
                </Form>
            </div>
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="invoiceOk">提交</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        props: ['invoiceshows', 'billed', 'billinfo'],
        data() {
            return {
                invoiceshow: false, // 弹窗是否显示
                type: 0, // 1普通 2专用
                invoiceOneValidate: { // 普通发票信息
                    title: '',
                    number: '',
                    content: ''
                },
                ruleinvoiceOneValidate: { // 普通发票验证
                    title: [
                        { required: true, trigger: 'blur' }
                    ],
                    number: [
                        { required: true, trigger: 'blur' }
                    ],
                    content: [
                        { required: true, trigger: 'blur' }
                    ]
                },
                invoiceTwoValidate: { // 增值税专用发票信息
                    title: '',
                    number: '',
                    address: '',
                    phone: '',
                    bankname: '',
                    banknumber: '',
                    content: ''
                },
                ruleinvoiceTwoValidate: { // 增值税专用发票验证
                    title: [
                        { required: true, trigger: 'blur' }
                    ],
                    number: [
                        { required: true, trigger: 'blur' }
                    ],
                    address: [
                        { required: true, trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, trigger: 'blur' }
                    ],
                    bankname: [
                        { required: true, trigger: 'blur' }
                    ],
                    banknumber: [
                        { required: true, trigger: 'blur' }
                    ],
                    content: [
                        { required: true, trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            invoiceOk () { // 确认按钮
                if (this.type == 1) {
                    this.$refs.invoiceOneValidate.validate(valid => {
                        if (valid) {
                            this.$emit('invoiceOk', this.invoiceOneValidate)
                            this.$Message.success('修改发票信息成功!')
                        } else {
                            this.$Message.warning('请填写完整信息!')
                        }
                    })
                } else {
                    this.$refs.invoiceTwoValidate.validate(valid => {
                        if (valid) {
                            this.$emit('invoiceOk', this.invoiceTwoValidate)
                            this.$Message.success('修改发票信息成功!')
                        } else {
                            this.$Message.warning('请填写完整信息!')
                        }
                    })
                }
            },
            invoiceCancel () { // 关闭弹窗
                this.$emit('invoiceCancel')
            }
        },
        watch: {
            invoiceshows () {
                this.invoiceshow = this.invoiceshows
                if (this.invoiceshows) {
                    this.type = this.billed
                    if (this.billed == 1) {
                        this.invoiceOneValidate.title = this.billinfo.billtitle
                        this.invoiceOneValidate.number = this.billinfo.billnumber
                        this.invoiceOneValidate.content = this.billinfo.billcontent
                    }
                    if (this.billed == 2) {
                        this.invoiceTwoValidate.title = this.billinfo.billtitle
                        this.invoiceTwoValidate.number = this.billinfo.billnumber
                        this.invoiceTwoValidate.address = this.billinfo.regaddress
                        this.invoiceTwoValidate.phone = this.billinfo.regphone
                        this.invoiceTwoValidate.bankname = this.billinfo.bankname
                        this.invoiceTwoValidate.banknumber = this.billinfo.banknumber
                        this.invoiceTwoValidate.content = this.billinfo.billcontent
                    }
                }
            }
        }
    }
</script>

<style scoped>

.invoice_box .ivu-form-item {
    margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/invoice.vue